import client from "./client";

/**
 * Register (or replace) this browser's FCM token with pusher-stc. The device id rides in the
 * X-Device-Id header (client interceptor). Sign-out is IAM's job: its event signs the tokens out.
 */
export async function registerPushDevice(token: string): Promise<void> {
  await client.put("/api/push/device", {
    platform: "WEB",
    appBuild: __APP_VERSION__,
    tokens: [{ provider: "FCM", token }],
  });
}
